export const totalCountTooltipLabel = "CWARYb";
export const totalCountUnreadCountTooltipLabel = "oKHuEe";
export const totalCountsUnreadCountTooltipLabel = "jGYDme";
export const totalCountContextMenuLabel = "Jva5mc";
export const totalCountUnreadCountContextMenuLabel = "ZSUSwd";
export const totalCountsUnreadCountContextMenuLabel = "KhxKXb";
export default {totalCountTooltipLabel,totalCountUnreadCountTooltipLabel,totalCountsUnreadCountTooltipLabel,totalCountContextMenuLabel,totalCountUnreadCountContextMenuLabel,totalCountsUnreadCountContextMenuLabel};